import { gql } from '@apollo/client';

export const ADMIN_PREVIEW_CB_TEAM_OWNERSHIP_TRANSFER = gql`
  query AdminPreviewCbTeamOwnershipTransfer(
    $input: AdminPreviewCbTeamOwnershipTransferInput!
  ) {
    adminPreviewCbTeamOwnershipTransfer(input: $input) {
      canTransfer
      checks {
        code
        title
        passed
        detail
      }
      estate {
        key
        count
      }
    }
  }
`;
